// @flow
import * as React from "react"
import withConnect from "hoc/withConnect"
import type { HOC, Component } from "recompose"
import { selectTheme } from "data/app/selectors"
import { selectLoggedIn } from "data/user/selectors"
import CustomElement from "components/CustomElement"
import SectionFooter from "components/SectionFooter"
import { HPaddedFullWidthContainer } from "componentsStyled/Layout/Containers"
import MainNav from "./MainNav"
import {
  BodyWrap,
  FooterWrap,
  HeaderWrap,
  MessageWrap,
  NavWrap,
  PageWrap,
} from "./styled"

const Page = ({ loggedIn, theme, filter: Filter, message: Message, children }) => {
  return (
    <PageWrap>
      <HeaderWrap>
        {theme &&
        <CustomElement html={theme.header.html} css={theme.header.css} />
        }
      </HeaderWrap>
      <NavWrap>
        <MainNav loggedIn={loggedIn} />
      </NavWrap>
      {Message &&
        <MessageWrap>
          <HPaddedFullWidthContainer>
            <Message />
          </HPaddedFullWidthContainer>
        </MessageWrap>
      }
      {Filter && <Filter />}
      <BodyWrap>
        {children}
      </BodyWrap>
      <FooterWrap>
        <SectionFooter />
        {theme &&
        <CustomElement html={theme.footer.html} css={theme.footer.css} />
        }
      </FooterWrap>
    </PageWrap>
  )
}

const mapStateToProps = state => ({
  loggedIn: selectLoggedIn(state),
  theme: selectTheme(state),
})

type Outter = {|
  children: React.Node,
  filter?: Component,
  message?: Component,
|}

const enhancer: HOC<*, Outter> = withConnect(mapStateToProps)

export default enhancer(Page)



// WEBPACK FOOTER //
// ./src/pages/_Page/index.js